@if (searches?.length) {
  <div class="recent-searches">
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h3 class="recent-searches__heading text-xs fw-500 text-uppercase mb-0">Recent Searches</h3>
      <button
        type="button"
        class="button-no-style text-xs text-secondary"
        (click)="clearAll.emit()"
      >
        Clear All
      </button>
    </div>

    <!-- List rows (Figma style: full-width, clock icon | text | category + × ) -->
    <ul class="list-unstyled mb-0">
      @for (search of searches; track search.text + search.category) {
        <li
          class="recent-searches__row d-flex align-items-center gap-2 py-2"
          role="button"
          (click)="select.emit(search)"
        >
          <!-- Clock icon -->
          <img src="images/Clock.svg" width="14" height="14" alt="recent" class="recent-searches__clock flex-shrink-0" fetchpriority="high" />

          <!-- Search text -->
          <span class="recent-searches__text text-break text-sm flex-grow-1">{{ search.text }}</span>

          <!-- Category label -->
          <span class="recent-searches__category text-xs flex-shrink-0 ms-auto">
            in&nbsp;<span class="fw-500">{{ search.category | getValueFromList: searchTypeLabels : 'value' : 'label' }}</span>
          </span>

          <!-- Remove button -->
          <button
            type="button"
            class="recent-searches__remove button-no-style d-flex align-items-center justify-content-center flex-shrink-0"
            (click)="onRemove(search, $event)"
            aria-label="Remove"
          >
            <img src="images/close.svg" width="12" height="12" alt="remove" />
          </button>
        </li>
      }
    </ul>
  </div>
}
